import { Toast } from "primereact/toast";
import { RefObject } from "react";
import { Company, Organization } from "../api/models/companies.models";
import { ReportStatus } from "../api/models/report.models";
import { Users } from "../api/models/user.models";

export enum Locale {
  FI = "fi",
  EN = "en",
  SWE = "swe",
}

export interface AdminReportFilters {
  company?: Company;
  year?: number;
  quarter?: number;
  month?: number;
  delegatedUser?: Users;
  delegatedTo?: Users;
  companyBusinessId?: string;
  organization?: Organization;
  skip?: number;
  take?: number;
  requiresApproval?: boolean;
  reportStatus?: ReportStatus;
}

export interface UIState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  bearerToken?: string;
  setBearerToken: (token?: string) => void;
  isLoggedIn: boolean;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  azureAdCode?: string;
  setAzureAdCode: (code?: string) => void;
  sessionExpired: boolean;
  setSessionExpired: (sessionExpired: boolean) => void;
  postLoginRedirectPath: string | null;
  setPostLoginRedirectPath: (path: string | null) => void;
  toastRef: RefObject<Toast> | null;
  companyId: number | null;
  setCompanyId: (companyId: number | null) => void;
  companyName: string | null;
  setCompanyName: (companyName: string | null) => void;
  organizationId: number | null;
  setOrganizationId: (organizationId: number | null) => void;
  organizationName: string | null;
  setOrganizationName: (organizationName: string | null) => void;
  // weights per year, year functioning as a key
  ecomodMaxWeights: { year: number; value: number }[];
  setEcomodMaxWeights: (
    ecomodMaxWeights: { year: number; value: number }[],
  ) => void;
  tempToken?: string;
  tempUserId?: number;
  setTempToken: (token?: string) => void;
  setTempUserId: (userId?: number) => void;
  selectedYearForNewReport: number | null;
  setSelectedYearForNewReport: (year: number | null) => void;
  selectedQuarterForNewReport: 1 | 2 | 3 | 4 | null;
  setSelectedQuarterForNewReport: (quarter: 1 | 2 | 3 | 4 | null) => void;
  selectedMonthForNewReport: number | null;
  setSelectedMonthForNewReport: (month: number | null) => void;
  theme: "light" | "dark";
  setTheme: (theme: "light" | "dark") => void;
  selectedAdminFilters: AdminReportFilters;
  setSelectedAdminFilters: (filters: AdminReportFilters) => void;
}
